import React from 'react';
import styled from 'styled-components';
import { Box, Button, Stack, SubtleText } from '@99designs/emu';
import { PackagePrice } from '../PackagePrice';
import type { Price as PriceType } from '../../types';

export interface CheckoutSummaryProps {
    pricing?: PriceType;
    cta: {
        key?: string;
        ref: React.Ref<HTMLButtonElement>;
        href: string;
    };
}

const StyledSubtleText = styled(SubtleText)`
    text-align: center;
`;

export function CheckoutSummary({ pricing, cta }: CheckoutSummaryProps) {
    return (
        <Stack space="1bu">
            {pricing && <PackagePrice price={pricing} />}

            <Button
                key={cta.key}
                ref={cta.ref}
                href={cta.href}
                width="fill"
                size="medium"
                disabled={!pricing}
            >
                {__('Continue to brief')}
            </Button>

            {pricing && (
                <Box display="flex" flexDirection="column" alignItems="center">
                    <StyledSubtleText>{__("You won't be charged yet.")}</StyledSubtleText>
                    <StyledSubtleText>
                        {__('Additional local tax may apply and will be calculated at checkout.')}
                    </StyledSubtleText>
                </Box>
            )}
        </Stack>
    );
}
